import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Link from 'components/common/Link/Link'
import Media from 'components/common/Media'
import { TIRES_LANDING_PAGE, BRAND_LANDING_PAGE } from 'constant'

const NoItemsInQuoteSubComponent = ({ closeHandler }) =>
  <ButtonWrapper>
    <Button button bolder to={ TIRES_LANDING_PAGE } onClick={ closeHandler }>
      Shop by Vehicle or Tire Size
    </Button>
    <Button button bolder to={ BRAND_LANDING_PAGE } onClick={ closeHandler }>
      Shop by Brand
    </Button>
  </ButtonWrapper>

export default NoItemsInQuoteSubComponent

NoItemsInQuoteSubComponent.propTypes = {
  closeHandler: PropTypes.func
}

const ButtonWrapper = styled.div`
  width: 100%;
  text-align: right;
  margin-top: 40px;
`

const Button = styled(Link)`
  ${Media.desktop`
    margin-left: 20px;
  `}
  ${Media.mobile`
    width: 100%;
    margin-bottom: 20px;
  `}
`
